/* eslint-disable @typescript-eslint/no-explicit-any */
import { toast } from 'react-toastify';
import { AnyAction } from 'redux';
import { all, getContext, put, takeEvery } from 'redux-saga/effects';
import { EndUsersManagementService } from '../service';
import {
	getEndUserCompletedLessons,
	getEndUserDetails,
	getEndUsers,
	getEndUsersFailure,
	getEndUsersSuccess,
	getGrammarLessonWordsReview,
	getSightLessonWordsReview,
	getSortingLessonWordsReview,
	getVerbLessonWordsReview,
	getVocabLessonWordsReview,
	handleEndUserActionFailure,
	handleEndUserActionSuccess,
	handleGetEndUserCompletedLessonsFailure,
	handleGetEndUserCompletedLessonsSuccess,
	handleGetEndUserDetailsFailure,
	handleGetEndUserDetailsSuccess,
	handleGetGrammarLessonWordsReviewFailure,
	handleGetGrammarLessonWordsReviewSuccess,
	handleGetSightLessonWordsReviewFailure,
	handleGetSightLessonWordsReviewSuccess,
	handleGetSortingLessonWordsReviewFailure,
	handleGetSortingLessonWordsReviewSuccess,
	handleGetVerbLessonWordsReviewFailure,
	handleGetVerbLessonWordsReviewSuccess,
	handleGetVocabLessonWordsReviewFailure,
	handleGetVocabLessonWordsReviewSuccess,
	handleLockEndUserAction,
	handleLockEndUserActionSuccess,
	handleResetPassEndUserAction,
	handleUnLockEndUserActionSuccess,
	handleUnlockEndUserAction,
	searchEndUsersByEmail,
	searchEndUsersByName,
	setSearchEndUsersByEmailResult,
	setSearchEndUsersByNameResult,
} from './slice';

function* getEndUsersHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new EndUsersManagementService(globalApplicationContext);
		const data = yield service.getEndUsers(action.payload);
		yield put(getEndUsersSuccess(data));
	} catch (e) {
		yield put(getEndUsersFailure(e));
		console.error(e);
	}
}

function* searchEndUsersByNameHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new EndUsersManagementService(globalApplicationContext);
		const data = yield service.searchEndUsersByName(action.payload.searchKey);
		yield put(setSearchEndUsersByNameResult(data));
	} catch (e) {
		console.error(e);
	}
}

function* searchEndUsersByEmailHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new EndUsersManagementService(globalApplicationContext);
		const data = yield service.searchEndUsersByEmail(action.payload.searchKey);
		yield put(setSearchEndUsersByEmailResult(data));
	} catch (e) {
		console.error(e);
	}
}

function* lockEndUserHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new EndUsersManagementService(globalApplicationContext);
		yield service.lockEndUser(action.payload.endUserId);
		yield put(handleLockEndUserActionSuccess(action.payload));
		toast.success('End user blocked successfully');
	} catch (e) {
		yield put(handleEndUserActionFailure(action.payload));
		console.error(e);
	}
}

function* unlockEndUserHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new EndUsersManagementService(globalApplicationContext);
		yield service.unlockEndUser(action.payload.endUserId);
		yield put(handleUnLockEndUserActionSuccess(action.payload));
		toast.success('End user unblocked successfully');
	} catch (e) {
		yield put(handleEndUserActionFailure(action.payload));
		console.error(e);
	}
}

function* sendEndUserResetPasswordHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new EndUsersManagementService(globalApplicationContext);
		yield service.sendEndUserResetPassword(action.payload.endUserId);
		yield put(handleEndUserActionSuccess(action.payload));
		toast.success('End user reset password email sent successfully');
	} catch (e) {
		yield put(handleEndUserActionFailure(action.payload));
		console.error(e);
	}
}

function* getEndUserDetailsHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new EndUsersManagementService(globalApplicationContext);
		const data = yield service.getEndUser(action.payload.endUserId);
		yield put(handleGetEndUserDetailsSuccess(data));
	} catch (e) {
		yield put(handleGetEndUserDetailsFailure({}));
		console.error(e);
	}
}

function* getEndUserCompletedLessonsHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new EndUsersManagementService(globalApplicationContext);
		const data = yield service.getEndUserCompletedLessons(
			action.payload.endUserId,
			action.payload.searchQuery,
		);
		yield put(handleGetEndUserCompletedLessonsSuccess(data));
	} catch (e) {
		yield put(handleGetEndUserCompletedLessonsFailure({}));
		console.error(e);
	}
}

function* getEndUserVocabLessonWordsReviewHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new EndUsersManagementService(globalApplicationContext);
		const data = yield service.getEndUserVocabLessonWordsReview(
			action.payload.endUserId,
			action.payload.lessonId,
		);
		yield put(handleGetVocabLessonWordsReviewSuccess(data));
	} catch (e) {
		yield put(handleGetVocabLessonWordsReviewFailure({}));
		console.error(e);
	}
}

function* getEndUserVerbLessonWordsReviewHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new EndUsersManagementService(globalApplicationContext);
		const data = yield service.getEndUserVerbLessonWordsReview(
			action.payload.endUserId,
			action.payload.lessonId,
		);
		yield put(handleGetVerbLessonWordsReviewSuccess(data));
	} catch (e) {
		yield put(handleGetVerbLessonWordsReviewFailure({}));
		console.error(e);
	}
}

function* getEndUserGrammarLessonWordsReviewHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new EndUsersManagementService(globalApplicationContext);
		const data = yield service.getEndUserGrammarLessonWordsReview(
			action.payload.endUserId,
			action.payload.lessonId,
		);
		yield put(handleGetGrammarLessonWordsReviewSuccess(data));
	} catch (e) {
		yield put(handleGetGrammarLessonWordsReviewFailure({}));
		console.error(e);
	}
}

function* getEndUserSortingLessonWordsReviewHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new EndUsersManagementService(globalApplicationContext);
		const data = yield service.getEndUserSortingLessonWordsReview(
			action.payload.endUserId,
			action.payload.lessonId,
		);
		yield put(handleGetSortingLessonWordsReviewSuccess(data));
	} catch (e) {
		yield put(handleGetSortingLessonWordsReviewFailure({}));
		console.error(e);
	}
}

function* getEndUserSightLessonWordsReviewHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new EndUsersManagementService(globalApplicationContext);
		const data = yield service.getEndUserSightLessonWordsReview(
			action.payload.endUserId,
			action.payload.lessonId,
		);
		yield put(handleGetSightLessonWordsReviewSuccess(data));
	} catch (e) {
		yield put(handleGetSightLessonWordsReviewFailure({}));
		console.error(e);
	}
}

export function* endUsersManagementSaga(): Generator<any, any, any> {
	yield all([
		takeEvery(getEndUsers, getEndUsersHandler),
		takeEvery(searchEndUsersByName, searchEndUsersByNameHandler),
		takeEvery(searchEndUsersByEmail, searchEndUsersByEmailHandler),
		takeEvery(handleLockEndUserAction, lockEndUserHandler),
		takeEvery(handleUnlockEndUserAction, unlockEndUserHandler),
		takeEvery(handleResetPassEndUserAction, sendEndUserResetPasswordHandler),
		takeEvery(getEndUserDetails, getEndUserDetailsHandler),
		takeEvery(
			getVocabLessonWordsReview,
			getEndUserVocabLessonWordsReviewHandler,
		),
		takeEvery(getEndUserCompletedLessons, getEndUserCompletedLessonsHandler),
		takeEvery(getVerbLessonWordsReview, getEndUserVerbLessonWordsReviewHandler),
		takeEvery(
			getGrammarLessonWordsReview,
			getEndUserGrammarLessonWordsReviewHandler,
		),
		takeEvery(
			getSortingLessonWordsReview,
			getEndUserSortingLessonWordsReviewHandler,
		),
		takeEvery(
			getSightLessonWordsReview,
			getEndUserSightLessonWordsReviewHandler,
		),
	]);
}
